// SPDX-License-Identifier: AGPL-3.0-or-later
import type {GatewayHandlerContext} from '@app/features/gateway/events/EventRouter';
import KonvoMail from '@app/features/konvo_mail/state/KonvoMail';

export function handleKonvoMailChanged(_data: unknown, _context: GatewayHandlerContext): void {
	KonvoMail.handleMailChanged();
}
